import classnames from 'classnames';
import React, { useId } from 'react';
import { v4 as uuid } from 'uuid';

import '@eika/radio-button-style/src/RadioButtons.scss';

import ErrorMessageLabel from './ErrorMessageLabel';
import RadioButton from './RadioButton';
import { RadioButtonLabel } from './RadioButtonLabel';
import { RadioButtonsProps } from './Types';
import { toDataTrackIdFormat } from './utils/toDataTrackIdFormat';

const RadioButtons = ({
    className,
    selectedOption,
    options,
    onChange,
    name,
    label,
    id,
    sublabel,
    infoButton,
    externalLinkLabel,
    errorMessage,
    dataTrackId,
    required = false,
    horizontal = false,
    ...rest
}: RadioButtonsProps): JSX.Element => {
    const generatedId = useId();
    const errorId = id ?? generatedId;
    return (
        <fieldset className={classnames('sgw-radio-buttons', className)}>
            <RadioButtonLabel
                label={label}
                sublabel={sublabel}
                infoButton={infoButton}
                externalLinkLabel={externalLinkLabel}
            />
            <div className={classnames({ 'sgw-radio-button__horizontal': horizontal })} {...rest}>
                {options.map(({ ref, ...option }) => (
                    <RadioButton
                        {...option}
                        key={option.key ?? uuid()}
                        selectedOption={selectedOption}
                        onChange={onChange}
                        name={name}
                        describedBy={errorId}
                        required={required}
                        error={!!errorMessage}
                        dataTrackId={dataTrackId}
                        dataTrackLinkname={
                            dataTrackId ? option.dataTrackLinkname || toDataTrackIdFormat(option.label) : undefined
                        }
                        inputRef={ref}
                    />
                ))}
            </div>
            <ErrorMessageLabel errorMessage={errorMessage} errorId={errorId} />
        </fieldset>
    );
};

export default RadioButtons;
